import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.42);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  animation: ${fadeIn} 0.2s ease;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  max-height: 100%;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  animation: ${slideIn} 0.25s ease;

  @media screen and (min-width: ${({ theme }) => theme.desktopMinWidth}px) {
    max-width: 960px;
  }
`;

export const HeadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  color: #1c1c1c;
`;

export const CloseBtn = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      background: #f4f4f4;
    }
  }
`;

export const Scroll = styled.div`
  flex: 1;
  min-height: 0;
  margin: 0 -16px;
  padding: 0 16px;
  overflow-y: auto;
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dedede;
    border-radius: 2px;
  }
`;

export const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;

  @media screen and (min-width: ${({ theme }) => theme.desktopMinWidth}px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  & + & {
    margin-top: 20px;
  }
`;

export const SectionTitle = styled.h3`
  grid-column: 1 / -1;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  color: #4d4d4d;
`;

export const LangButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 46px;
  padding: 12px 16px;
  border: 1px solid ${({ $active }) => ($active ? '#f7b98d' : 'transparent')};
  border-radius: 12px;
  background: ${({ $active, theme }) => ($active ? theme.colors.optionActive : 'transparent')};
  color: ${({ $active }) => ($active ? '#1c1c1c' : '#6c6c6c')};
  font-size: 16px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  line-height: 22px;
  text-align: start;
  cursor: pointer;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background: ${({ $active, theme }) => ($active ? theme.colors.optionActive : '#f4f4f4')};
    }
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

export const Flag = styled.img`
  flex-shrink: 0;
  width: 28px;
  height: 20px;
  border-radius: 3px;
  object-fit: cover;
`;
